import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PlainImageComponent, PlainImageSection } from '../../components/plain-image/plain-image.component';
import { LinkSection } from '../../types/link';
import { AnyInnerSection, Section, SectionAttributes } from '../../../app/types/section';


import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { InnerSectionComponent } from '../inner-section/inner-section.component';
import { RouterOrExternalLinkDirective } from '@knorr-bremse-portals/ngx-components';
import { CardComponent } from '@knorr-bremse-portals/ngx-components/components/card';
import { StandaloneLinkComponent } from '@knorr-bremse-portals/ngx-components/components/standalone-link';

export interface TeaserCardAttributes extends SectionAttributes {
  numColumns: 4;
  text: string;
  medium: PlainImageSection;
  headline?: string;
  subline?: string;
  link?: LinkSection;
}

type TeaserCardEditorIds = [
  'headline',
  'text',
  'subline',
]

export type TeaserCardSection = Section<TeaserCardAttributes, TeaserCardEditorIds, 'teaser-card'>;

export function isTeaserCardSection(section: AnyInnerSection): section is TeaserCardSection {
  return section.component === 'teaser-card';
}

@Component({
    selector: 'app-teaser-card',
    styleUrls: ['./teaser-card.component.scss'],
    templateUrl: './teaser-card.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        EditorIdDirective,
        PlainImageComponent,
        RouterOrExternalLinkDirective,
        CardComponent,
        StandaloneLinkComponent,
    ],
})
export class TeaserCardComponent extends InnerSectionComponent<TeaserCardSection> {

}
